import React from 'react';
import { useTranslation } from 'react-i18next';

// The required-field marker. A word, not an asterisk: screen readers skip a bare
// "*".
// `size="sm"` has tighter padding, for dense panels. `size="xs"` is for the
// webhook builder's field labels: 12px text, and a margin, since those labels
// are flex rows, which drop the leading space (and never wrap, so the margin
// can't indent a wrapped tag).
const RequiredTag = ({ size = 'md' }: { size?: 'md' | 'sm' | 'xs' }) => {
  const { t } = useTranslation();
  const sizing = {
    md: 'px-1.5 py-0.5 text-body-sm',
    sm: 'px-1 py-px text-body-sm',
    xs: 'ml-1.5 px-1 py-px text-[12px]',
  }[size];
  // Widens the space before the tag to the gap it needs beside the label.
  const gap = size === 'md' ? '[word-spacing:4px]' : '[word-spacing:2px]';

  return (
    // The leading space separates it in the label's accessible name, which is
    // the text run together ("Email Required", not "EmailRequired"). It is
    // also the gap: a space where the line wraps takes no room, so a tag that
    // drops to its own line starts flush left, where a margin would indent it.
    <>
      <span className={gap}> </span>
      <span
        className={`${sizing} rounded bg-greyscale-10 align-middle font-normal leading-4 text-greyscale-5 transition-colors duration-300`}
      >
        {t('Required')}
      </span>
    </>
  );
};

export default RequiredTag;
